import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/what-we-do.jpg";
import "../Pages/OurHistory.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function WhatWeDo() {
  return (
    <div className="ne-page">
      <SEO
        title="What We Do"
        description="CIRCODU delivers consultancy, independent monitoring and evaluation, research, capacity building, and cookstove testing laboratory services to drive sustainable development in Uganda and beyond."
        keywords="CIRCODU, consultancy services, independent monitoring and evaluation, research initiatives, capacity building, cookstove testing laboratory services, sustainable development, Uganda, clean energy, carbon finance, environmental conservation, rural development, sustainable livelihoods, cookstove performance testing, ISO standards for cookstoves, CIRCODU services Uganda"
        url="/about-us/what-we-do"
        type="website"
      />

      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">What We Do</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">About Us</Breadcrumb.Item>
            <Breadcrumb.Item className="text1">What We Do</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="section border-bottom">
        <div className="container border-top">
          <div className="row">
            <div className="col-md-12 mt-2">
              <p className="texty">
                At CIRCODU, our expertise is your advantage. We deliver a
                comprehensive suite of services designed to inform decisions,
                strengthen communities, and drive sustainable development
                locally and across the continent.
              </p>
            </div>
            <div className="col-md-12">
              <p className="texty">
                <b>📋 Consultancy Services:</b> From baseline assessments and
                feasibility evaluations to market intelligence studies and
                project appraisals, CIRCODU brings deep expertise and robust
                capabilities to every consultancy engagement. Whether you're
                launching a new initiative or refining an existing one, we
                provide the insights you need to move forward with confidence.
              </p>
              <p className="texty">
                <b>📊 Independent Monitoring and Evaluation Services:</b>{" "}
                Objectivity matters. CIRCODU is a trusted third-party monitoring
                and evaluation partner for domestic, commercial, and
                institutional energy projects across Uganda and beyond. Our
                independent assessments ensure accountability, transparency, and
                results that stand up to scrutiny.
              </p>
              <p className="texty">
                <b>🔬 Research Initiatives:</b> Science drives everything we do.
                In collaboration with world-renowned institutions including the
                University of California at Berkeley, Stanford University,
                Humboldt State University, and Makerere University, CIRCODU has
                successfully led multiple research projects spanning household
                energy technologies, public health, and environmental
                conservation. Global partnerships. Local impact.
              </p>
              <p className="texty">
                <b>🎓 Capacity Building:</b> Knowledge shared is power
                multiplied. CIRCODU designs and delivers tailored training and
                skills development programs for communities, equipping both
                learners and trainers with the practical tools they need to
                thrive. Because lasting change starts with people.
              </p>
              <p className="texty">
                <b>🔥 Cookstoves and Fuel Testing Laboratory Services:</b>{" "}
                CIRCODU operates a state-of-the-art cookstove testing laboratory
                that adheres to the rigorous standards set by the International
                Organization for Standardization (ISO). This facility is
                dedicated to evaluating the performance, safety, and emissions
                of cookstoves, ensuring that they meet the highest quality
                standards for use in households and communities.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WhatWeDo;
